export const API_URL = " https://forkify-api.herokuapp.com/api/v2/recipes/";
export const TIMEOUT_SEC = 10;
export const RES_PER_PAGE = 10;
export const KEY = "77f4a19a-18f2-4221-836f-0110f5c0fa5d";
export const MODAL_CLOSE_SEC = 2.5;
